<template>
  <v-layout>
    <v-flex v-if="bullet" shrink class="padding-left-0">
      <div class="bullet-container" :style="{ backgroundColor: color ? color : '#ff4c00' }">
        <div class="bullet-content">{{ bullet }}</div>
      </div>
    </v-flex>

    <v-flex shrink>
      <v-layout justify-center>
        <v-flex class="module-title" :style="{ color: color ? color : '#ff4c00', ...fontStyle }">
          {{ title }}
        </v-flex>
      </v-layout>
      <v-layout v-if="description" justify-center>
        <v-flex
          class="module-description"
          :style="{ color: color ? color : '#ff4c00', ...fontStyle }"
        >
          {{ description }}
        </v-flex>
      </v-layout>
      <v-layout v-if="showTicketSwapButton" class="pt-3" justify-center>
        <v-flex>
          <main-button
            color="black"
            type="button"
            :text="
              $vuetify.breakpoint.xsOnly ? $t('checkOnTicketSwapShort') : $t('checkOnTicketSwap')
            "
            :href="getTicketSwapEventPage"
            target="_blank"
          />
        </v-flex>
      </v-layout>
      <v-layout v-if="showEventsButton" :class="{ 'pt-3': !showTicketSwapButton }" justify-center>
        <v-flex>
          <main-button
            color="black"
            type="button"
            :text="$t('viewAllEvents')"
            outline
            :href="getEventsPageUrl"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'module-title',
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    bullet: {
      type: String || Number,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    fontStyle: {
      type: [Object, Boolean],
      default: () => ({}),
    },
    showEventsButton: {
      type: Boolean,
      default: false,
    },
    showTicketSwapButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getEventsPageUrl() {
      return process.env.VUE_APP_LANDING_URL
    },
    getTicketSwapEventPage() {
      const TICKET_SWAP_BASE_URL = 'https://www.ticketswap.com'
      if (!this.event) {
        return TICKET_SWAP_BASE_URL
      }
      let searchQuery = `${this.event.title}`
      if (this.event.location && this.event.location.venue) {
        searchQuery += ` ${this.event.location.venue}`
      } else if (this.event.location && this.event.location.city) {
        searchQuery += ` ${this.event.location.city}`
      }
      const encodedSearchQuery = encodeURIComponent(searchQuery)

      return `${TICKET_SWAP_BASE_URL}/search?query=${encodedSearchQuery}`
    },
  },
}
</script>

<style>
.padding-left-0 {
  padding-left: 0px !important;
}

.module-title {
  font-family: 'Raleway';
  font-weight: 800;
  font-size: 36px;
  line-height: 43px;
  color: #0277bd;
  max-width: 493px;
}

.module-description {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  max-width: 493px;
  padding-top: 10px;
}

.bullet-container {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
}

.bullet-content {
  font-family: Raleway;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}
</style>
